import React, { useEffect, useState } from "react";
import "bootstrap/dist/js/bootstrap.bundle";
import "../../../../../styles/userManagement.css";
import ModalComponent from "../../../../Common/DeleteModal";
import displayToastMessage from "../../../../Common/Alert/displayToastMessage";
import LoaderScreen from '../../../../Common/loaderScreen'
import EditVendorRequest from "./editVendorRequest";
import APIService from "../../../../../services/apiAxiosService.js";
import useHttp from "../../../../../hooks/useHttp.js";
import {Table, Column} from "@appkit4/react-components/table";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";

function ViewAllThirdPartyRequests(props) {
  const [modalVisible, setModalVisible] = useState(false);
  const [editScreen, setEditScreen] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [deleteSelected, setDeleteSelected] = useState("");
  const [dataLoader, setDataLoader] = useState(false);
  const [edit, setEdit] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);
  const [search, setSearch] = useState("");
  const { sendRequest: getTPDataById } = useHttp();
  const { sendRequest: deleteTPRequestData } = useHttp();
  const { sendRequest: getCreatedTPRequests } = useHttp();
  let { vendorRequests } = props;
  

  useEffect(() => {
    setTableData(vendorRequests);
    setFilter(vendorRequests);
    let totalPageLength = Math.ceil((vendorRequests?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [vendorRequests]);

  useEffect(() => {
    const result = tableData?.filter((vendorList) => {
      return vendorList?.vendorName.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
    let totalPageLength = Math.ceil((result?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
      setTotalPage(totalPageLength);
  }, [search]);

  let handelRefreshPage = () => {
    setTableData(vendorRequests);
    setFilter(vendorRequests);
    let totalPageLength = Math.ceil((vendorRequests?.length)/10);
      if (totalPageLength === 0) {
        totalPageLength = 1;
      }
    setTotalPage(totalPageLength);
  }

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
  }

  const getByTPRequestID = async (ID) => {
    setDataLoader(true)
    getTPDataById(APIService.getTPDataById(ID), responseHandler, errorHandler)
    setDataLoader(false)
  };

  const responseHandler = (result) => {
    if (result.CODE && result.MSG.length > 0) {
      setVendorData(result.MSG);
      setEditScreen(true);
      setSearch("");
    } else {
      displayToastMessage("Record not found", "error");
      setSearch("");
    }
  }

  const errorHandler = () => {
    displayToastMessage("Something went wrong, Please try again!", "error");
    setDataLoader(false);
    setSearch("");
  }

  const handleCancel = () => {
    setModalVisible(false);
    setSearch("");
  };

  const responseHandlerTPRequests = (json) => {
    if (json.CODE) {
      setTableData(json.MSG);
      setFilter(json.MSG);
      let totalPageLength = Math.ceil((json.MSG?.length)/10);
        if (totalPageLength === 0) {
          totalPageLength = 1;
        }
      setTotalPage(totalPageLength);
      setDataLoader(false);
      setSearch("");
    }
  }

  const handleConfirm = async (id) => {
    setModalVisible(false);
    let data = {
      userId: Number(sessionStorage.getItem("userId")),
      vendorId: deleteSelected,
      email:sessionStorage.getItem("email")
    };
    deleteTPRequestData(APIService.deleteTPRequestData(data), (result) => {
      if (result.CODE) {
        displayToastMessage("Deleted Successfully", "success");
        getCreatedTPRequests(APIService.getCreatedTPRequestsService(), 
        responseHandlerTPRequests, 
        errorHandler
    )
      }
    }, errorHandler)
  };

  const handleBack = () => {
    setEditScreen(false);
    setSearch("");
    getCreatedTPRequests(APIService.getCreatedTPRequestsService(), 
    responseHandlerTPRequests, 
    errorHandler
    )
  };

  const renderActionCell = (row) => {
    if (row?.statusId !== 1) {
    return(
      <>
        <span className="Appkit4-icon icon-view-fill action-icon pointer" title="View TPRequest" onClick={() => handleViewButton(row)}></span>&nbsp;
        <span className="action-icon Appkit4-icon icon-delete-fill pointer" title="Delete TPRequest" onClick={() => handleDeleteButton(row)}></span>&nbsp;
        <span className="action-icon Appkit4-icon icon-edit-fill pointer vendor-edit" title=" Edit TPRequest" onClick={() => handleEditButton(row)}></span>
      </>
    )
    }
    else {
      return (
        <>
        <span className="Appkit4-icon icon-view-fill action-icon pointer" title="View TPRequest" onClick={() => handleViewButton(row)}></span>&nbsp;
        <span className="action-icon Appkit4-icon icon-delete-fill pointer" title="Delete TPRequest" onClick={() => handleDeleteButton(row)}></span>
        </>
      )
    }
  }

  const handleViewButton = (row) => {
    getByTPRequestID(row?.vendorAssessReqId);
    setEdit(false);
  }

  const handleEditButton = (row) => {
    getByTPRequestID(row?.vendorAssessReqId);
    setEdit(true);
  }

  const handleDeleteButton = (row) => {
    setDeleteSelected(row?.vendorAssessReqId);
    setModalVisible(true);
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.vendorName).charAt(1);
    const secondOrderId = (b.vendorName).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

  const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.vendorName).charAt(1);
    const secondOrderId = (b.vendorName).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
}

  const renderStatusCell = (row) => {
    let stylesClass;
    switch (row.statusName) {
      case "Expired":
      stylesClass = "Expired-status";
      break;
      case "Open":
      stylesClass = "Open-status";
      break;
      case "Close":
      stylesClass = "Close-status";
      break;
      case "Draft":
      stylesClass = "Draft-status";
      break;
      default:
      stylesClass = "";
    }
    let className = "bia-status " + stylesClass;
    return <div className={className}>{row.statusName}</div>
}

  const renderDateCell = (row) => {
    if (row?.assessReqEndAfter != null) {
    return formatDate(row?.assessReqEndAfter)
    }
    else return "";
  }

  const renderDateCellCreated = (row) => {
    return formatDate(row?.createdDate);
  }

  return (
    <div className="App">
      {dataLoader ? (
        <LoaderScreen />
      ) : (
        <div>
          {editScreen ? (
            <EditVendorRequest
              handelRefresh={handelRefreshPage}
              handleBack={handleBack}
              selectedRequest={vendorData}
              Edit={edit}
            />
          ) : (
            <div className="col-lg-12 mt-3 pl-1">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Third Party Name"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
              <div className="ap-table-demo">
                <Table originalData={filter} className={filter.length === 0 ? "" : "biaTableBU"} hasTitle currentPage={current} pageSize={10}>
                    <Column field="vendorName" className={filter.length === 0 ? "" : "oneFifty"} sortKey={filter.length > 0 ? "vendorName" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Third Party Name</Column>
                    <Column field="email_id" className={filter.length === 0 ? "" : "oneEighty"} sortKey={filter.length > 0 ? "vendorName" : ""}>Third Party Email ID</Column>
                    <Column field="statusName" sortKey={filter.length > 0 ? "statusName" : ""} renderCell={renderStatusCell}>Status</Column>
                    <Column field="city" sortKey={filter.length > 0 ? "city" : ""}>City</Column>
                    <Column field="assessmentType" sortKey={filter.length > 0 ? "assessmentType" : ""} className={filter.length === 0 ? "" : "oneFifty"}>Assessment Type</Column>
                    <Column field="createdDate" sortKey={filter.length > 0 ? "createdDate" : ""} renderCell={renderDateCellCreated} className={filter.length === 0 ? "" : "oneFifty"}>Created On</Column>
                    <Column field="vendorAssessReqId"
                    renderCell={renderActionCell}
                    className={filter.length === 0 ? "" : "oneFifty"}
                    >Action</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                  </div>
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
          )}
        </div>)}
      <ModalComponent
        visible={modalVisible}
        cancel={handleCancel}
        confirm={handleConfirm}
      />
    </div>
  );
}
export default ViewAllThirdPartyRequests;
